import React from 'react';
import {
    TextInput,
    DateInput,
    SelectInput,
    SimpleForm,
    Edit,
    LongTextInput,
    TabbedForm,
    FormTab,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Notification,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';

const editStyles = {
    root: { alignItems: 'flex-start' },
};

const shippingReady = [
    {
            id : 'Y',
            name: 'Yes'
    },
    {
            id: 'N',
            name: 'No'
    }
]

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const EditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} label='Shipping List'/>
    </CardActions>
);


const ShippingToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const ShipmentEdit = props => (
    <ErrorBoundary>  
    <Edit title='Edit Shipment' {...props} actions={<EditActions/>}> 
        <SimpleForm toolbar={<ShippingToolbar />}>
        <Table  style={{ margin: 'auto',  fontSize:'12px' , width:"100%"}} >  
            <TableBody size="x-small"> 
                <TableRow >
                    <TableCell align="left"><SanitizedTextInput source="shipping_case_no" label="Shipping Case Number" validate={required()}/></TableCell>
                    <TableCell align="left"><DateInput source="shipping_date" label="Shipping Date" locales="en-us"/></TableCell>
                </TableRow>                
                <TableRow >
                    <TableCell align="left"><SanitizedTextInput source="case_no" label="Case Number" /></TableCell>
                    <TableCell align="left"><SanitizedTextInput source="ucn" label="Unit Control Number" validate={required()} /></TableCell>
                </TableRow>                            
                <TableRow >  
                    <TableCell align="left"><SanitizedTextInput source="ssn" label="SSN" /></TableCell>         
                    <TableCell align="left"><SanitizedTextInput source="name"  disabled label="Name" /></TableCell>        
                </TableRow>
            </TableBody>
        </Table>
        </SimpleForm>
        
    </Edit>
    </ErrorBoundary>  
);

export default withStyles(editStyles)(ShipmentEdit);